import React, { PropsWithChildren } from 'react';
import classNames from 'classnames';
import styles from './Tooltip.module.scss';

export const Tooltip = ({
    className, active, children,
    align = 'center', position = 'top'
}: Props) => {

    const classes = classNames(styles.default, className, {
        [styles[align!]]: align,
        [styles[position!]]: position,
        [styles.active]: active
    });

    return (
        <div className={classes}>
            {children}
        </div>
    );
};

type Props = PropsWithChildren<{
    position?: 'top' | 'right' | 'bottom' | 'left';
    align?: 'start' | 'center' | 'end';
    className?: string;
    active: boolean;
}>;